class FaqSection extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.js-faq-section-toggle')
    this.content = this.querySelector('.js-faq-section-content')
    this.toggleAll = document.querySelectorAll('.js-faq-section')
    this.toggleTopicAll = document.querySelectorAll('.js-faq-answer')
    
    this.toggle.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this))
  }

  onClick(event) {
    event.preventDefault();

    this.toggleTopicAll.forEach((element) => {
      let openElement = element
      if(openElement.classList.contains('open')) {
        openElement.classList.remove('open')
      }
    })

    this.toggle.parentElement.classList.contains('open')
      ? this.close()
      : this.open()
  }

  close() {
    let content = document.querySelector('.js-faq-content')
    let box = document.querySelector('.js-faq-body')

    content.classList.remove('hidden')
    box.classList.add('hidden')

    this.toggle.parentElement.classList.remove('open')
    
  }

  open() {
    this.toggleAll.forEach((element) => {
      let openElement = element
      if(openElement.classList.contains('open')) {
        openElement.classList.remove('open')
      }
    })

    this.toggle.parentElement.classList.add('open')
  }

  onKeyUp(event) {
    if (event.target.classList.contains('js-faq-section-toggle')) {
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close()
      } else if (event.code.toUpperCase() === 'ENTER') {
        this.onClick(event)
      } else {
        return
      }
    }  
  }
}

customElements.define('faq-section', FaqSection)

class FaqAnswer extends HTMLElement {
  constructor() {
    super();
    this.toggle = this.querySelector('.js-faq-answer-toggle')
    this.content = this.querySelector('.js-faq-answer-content')
    this.toggleAll = document.querySelectorAll('.js-faq-answer')
    
    this.toggle.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keyup', this.onKeyUp.bind(this))
    this.currentUrl();
  }

  currentUrl() {
    let urlHash = document.location.hash;
    let accordionLink = this.toggle.hash
    
    if (urlHash === accordionLink) {
      console.log(urlHash)
      console.log(this.toggle.parentElement)
      this.toggle.closest('.js-faq-section').classList.add('open')
      this.toggle.click()
      this.toggle.parentElement.classList.add('active')
      trapFocus(this.toggle.parentElement, this.toggle)
    }
  }

  onClick(event) {
    //event.preventDefault();
    this.toggle.parentElement.classList.contains('open')
      ? this.close()
      : this.open()
  }

  close() {
    this.toggle.parentElement.classList.remove('open')
  }

  open() {
    this.toggleAll.forEach((element) => {
      let openElement = element
      if(openElement.classList.contains('open')) {
        openElement.classList.remove('open')
      }
    })
   
    let content = document.querySelector('.js-faq-content')
    let box = document.querySelector('.js-faq-body')
    let moveContent = this.content;
    moveContent = moveContent.cloneNode(true)

    content.classList.add('hidden')
    box.classList.remove('hidden')
    box.innerHTML = ''
    box.appendChild(moveContent);
    
    this.toggle.parentElement.classList.add('open')
  }

  onKeyUp(event) {
    if (event.target.classList.contains('js-faq-answer-toggle')) {
      let openDetailsToggle = event.target.closest('.js-faq-section').querySelector('.js-faq-section-toggle')
      if (event.code.toUpperCase() === 'ESCAPE') {
        this.close()
        trapFocus(openDetailsToggle.parentElement, openDetailsToggle)
      } else {
        return
      }
    }  
  }
}

customElements.define('faq-answer', FaqAnswer)
